import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import PublicNav from '../components/PublicNav';
import Footer from '../components/Footer';
import EditorialContentSection from '../components/EditorialContentSection';

const ASPEN_RIDGE_SITE = 'https://aspenridgegardendesign.com';

function usePublicUserId() {
  try {
    const raw = localStorage.getItem('userData') || localStorage.getItem('user');
    if (!raw) return null;
    return JSON.parse(raw)?.id || null;
  } catch {
    return null;
  }
}

export default function WatchPage() {
  const currentUserId = usePublicUserId();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <PublicNav currentUserId={currentUserId} />
      <main className="flex-1 max-w-5xl mx-auto px-4 py-10 sm:py-14 w-full">
        <h1 className="text-3xl font-bold text-gray-900">Watch &amp; tips</h1>
        <p className="mt-3 text-gray-600 max-w-2xl leading-relaxed">
          Short videos and practical takeaways from real landscape projects. Start with John Connors at AspenRidge Garden
          Design — we will add more PlantADay picks below as we publish them.
        </p>
        <p className="mt-4">
          <a
            href={ASPEN_RIDGE_SITE}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-green-700 hover:text-green-900 hover:underline"
          >
            Visit AspenRidge Garden Design
            <ExternalLink className="w-4 h-4 flex-shrink-0" aria-hidden />
          </a>
        </p>

        <div className="mt-10 rounded-2xl border border-gray-200 bg-white overflow-hidden shadow-sm">
          <div className="px-5 py-4 border-b border-gray-100">
            <h2 className="text-lg font-semibold text-gray-900">Real consult walkthrough</h2>
            <p className="mt-1 text-sm text-gray-600">
              See how a landscape project starts — goals, constraints, and first ideas on site.
            </p>
          </div>
          <div className="relative w-full" style={{ paddingBottom: '56.25%', height: 0 }}>
            <iframe
              className="absolute top-0 left-0 w-full h-full"
              src="https://www.youtube.com/embed/OFy2evDZLZ0"
              title="Initial Consult with Jackie and Aaron from Victoria BC"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>

        <div className="mt-12">
          <h2 className="text-base font-semibold text-gray-900 mb-1">More from PlantADay</h2>
          <p className="text-sm text-gray-600 mb-6 max-w-2xl">
            Extra clips and links we curate for homeowners. If nothing appears yet, check back soon or use Get Ideas to
            ask your own question.
          </p>
          <EditorialContentSection
            tag="watch"
            title={null}
            emptyMessage="More videos and tips are on the way. In the meantime, explore Get Ideas or watch the consult above."
          />
        </div>

        <p className="mt-10 text-sm text-gray-500 flex flex-wrap gap-x-4 gap-y-2">
          <Link to="/ideas" className="text-green-700 font-medium hover:underline">
            Get Ideas
          </Link>
          <Link to="/" className="text-green-700 font-medium hover:underline">
            Home
          </Link>
        </p>
      </main>
      <Footer />
    </div>
  );
}
